module.exports = __webpack_public_path__ + "static/media/Oakwood-HR-coaching-illustration.ed3b7fe0.svg";